import './launchpad-embed-reset';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { Toaster } from '@eureca/ui';
import { setBaseUrl } from '@eureca/admin-api-sdk/client';
import { KeycloakGate } from './auth/KeycloakGate';
import { adminEnv } from './config/env';
import { queryClient } from './lib/query-client';
import { router } from './router/router';
import './index.css';

// Aponta o SDK pro host do BFF resolvido em runtime (eureca.dev vs eureca.me),
// não pro VITE_API_URL baked (o mesmo bundle CF Pages serve vários hosts).
setBaseUrl(adminEnv.apiUrl);

const root = document.getElementById('root');
if (!root) throw new Error('Root element not found');

createRoot(root).render(
  <StrictMode>
    <KeycloakGate>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} context={{ query: queryClient }} />
        <Toaster />
      </QueryClientProvider>
    </KeycloakGate>
  </StrictMode>
);
